import React, { useEffect } from 'react';

import { IconButton } from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import {
	DynamicSurfaceView,
	useAIContext,
	useViewAIActions,
	type ViewConfig,
} from '@atlassian/ai-smart-button-api';

import {
	DYNAMIC_SURFACE_PANEL_ID,
	getDynamicSurfacePanelHeaderElements,
	i18n,
	// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
} from '../ai-dynamic-surface/useDynamicSurfacePanel';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import type { ObjectSidebar } from '../common/types/object-sidebar-types';

type AIFeatureViewProps = {
	view: ViewConfig | undefined;
	objectSidebar: ObjectSidebar;
};

const atlaskitCssStyles = cssMap({
	heightStyles: {
		height: '100%',
	},
});

export const AIFeatureView = ({ view, objectSidebar }: AIFeatureViewProps) => {
	const { changeView } = useViewAIActions();
	const context = useAIContext();
	const { changeHeaderElements } = objectSidebar.actions;
	const panelTitle = context?.reference ? i18n.referencingPanelTitle : undefined;

	useEffect(() => {
		changeHeaderElements(DYNAMIC_SURFACE_PANEL_ID, {
			HeaderIcon: () => (
				<IconButton
					testId="ai-feature-view-back-button"
					appearance="subtle"
					label=""
					icon={ArrowLeftIcon}
					onClick={() => changeView(DynamicSurfaceView.Default)}
				/>
			),
		});
	}, [changeHeaderElements, changeView]);

	useEffect(() => {
		return () => {
			changeHeaderElements(
				DYNAMIC_SURFACE_PANEL_ID,
				getDynamicSurfacePanelHeaderElements({ panelTitle }),
			);
		};
		// Reset Header Elements on unmount
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!view) {
		return null;
	}

	return (
		<Stack xcss={atlaskitCssStyles.heightStyles}>
			<Box paddingInline="space.200" xcss={atlaskitCssStyles.heightStyles}>
				{view?.render()}
			</Box>
		</Stack>
	);
};
